<template>
  <header class="nav-header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/images/logo.jpg" alt="Logo">
          </router-link>
        </div>
        
        <!-- 移动端菜单按钮 -->
        <button class="menu-btn" @click="toggleMobileNav">
          <i class="el-icon-menu"></i>
        </button>
        
        <!-- 桌面端导航 -->
        <nav class="desktop-nav">
          <router-link to="/" class="nav-item">首页</router-link>
          <router-link to="/solutions" class="nav-item">解决方案</router-link>
          <router-link to="/products" class="nav-item">产品中心</router-link>
          <!-- <router-link to="/cases" class="nav-item">成功案例</router-link> -->
          <router-link to="/support" class="nav-item">服务与支持</router-link>
          <router-link to="/about" class="nav-item">关于我们</router-link>
          <router-link to="/contact" class="nav-item">联系我们</router-link>
          <!-- <el-button type="primary" size="small" @click="contactUs">联系我们</el-button> -->
          <el-button type="primary" size="small" @click="login">登录云平台</el-button>
          <el-button type="success" size="small" @click="international">国际流量</el-button>
        </nav>
      </div>
    </div>
    
    <!-- 移动端导航菜单 -->
    <div class="mobile-nav" :class="{ active: isMobileNavOpen }">
      <div class="nav-header">
        <h2>菜单</h2>
        <button class="close-btn" @click="toggleMobileNav">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="nav-content">
        <router-link to="/" class="nav-item" @click.native="handleNavClick">首页</router-link>
        <router-link to="/solutions" class="nav-item" @click.native="handleNavClick">解决方案</router-link>
        <router-link to="/products" class="nav-item" @click.native="handleNavClick">产品中心</router-link>
        <!-- <router-link to="/cases" class="nav-item" @click.native="handleNavClick">成功案例</router-link> -->
        <router-link to="/about" class="nav-item" @click.native="handleNavClick">关于我们</router-link>
        <el-button type="primary" size="small" @click="handleContactClick" class="contact-btn">联系我们</el-button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavHeader',
  data() {
    return {
      isMobileNavOpen: false
    }
  },
  methods: {
    toggleMobileNav() {
      this.isMobileNavOpen = !this.isMobileNavOpen;
      // 当菜单打开时禁止页面滚动
      if (this.isMobileNavOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    handleNavClick() {
      this.isMobileNavOpen = false;
      document.body.style.overflow = '';
    },
    handleContactClick() {
      this.isMobileNavOpen = false;
      document.body.style.overflow = '';
      this.$router.push('/contact');
    },
    contactUs() {
      this.$router.push('/contact');
    },
    login(){
      window.location.href = 'https://iot.juzi1688.cn/';
    },
    international(){
      window.open('https://juziiot.com/', '_blank');
    }
  },
  beforeDestroy() {
    // 组件销毁前恢复页面滚动
    document.body.style.overflow = '';
  }
}
</script>

<style lang="scss" scoped>
.nav-header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    
    .logo {
      img {
        height: 40px;
        width: auto;
      }
    }
    
    .desktop-nav {
      display: flex;
      align-items: center;
      
      .nav-item {
        color: #333;
        text-decoration: none;
        padding: 0 20px;
        font-size: 16px;
        transition: color 0.3s;
        
        &:hover {
          color: #409EFF;
        }
        
        &.router-link-active {
          color: #409EFF;
        }
      }
      
      .el-button {
        margin-left: 20px;
      }
    }
  }
}

.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  
  &.active {
    transform: translateX(0);
  }
  
  .nav-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 1001;
    
    h2 {
      margin: 0;
      font-size: 18px;
      color: #333;
    }
    
    .close-btn {
      font-size: 24px;
      color: #666;
      background: none;
      border: none;
      padding: 5px;
      cursor: pointer;
    }
  }
  
  .nav-content {
    padding: 20px;
    
    .nav-item {
      display: block;
      padding: 15px 0;
      color: #333;
      text-decoration: none;
      font-size: 16px;
      border-bottom: 1px solid #eee;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover {
        color: #409EFF;
      }
      
      &.router-link-active {
        color: #409EFF;
      }
    }
    
    .contact-btn {
      width: 100%;
      margin-top: 20px;
      height: 44px;
      font-size: 16px;
    }
  }
}

@media screen and (max-width: 768px) {
  .nav-header {
    .header-content {
      height: 50px;
      
      .logo {
        img {
          height: 30px;
        }
      }
      
      .desktop-nav {
        display: none;
      }
    }
  }
  
  .menu-btn {
    display: block;
    background: none;
    border: none;
    font-size: 24px;
    color: #333;
    padding: 5px;
    cursor: pointer;
  }
}
</style> 